import { gql } from "@apollo/client";

export const SET_INTEGRATION = gql`
  mutation SetIntegration($input: IntegrationInput!) {
    setIntegration(input: $input)
  }
`;
